import { PaddedSurface } from "App/global-style";
import styled from "styled-components";

export const Surface = styled(PaddedSurface)`
  & + & {
    margin-top: ${({ theme }) => theme.spacing.lg};
  }
`;
